import {Component, ViewChild, OnInit} from '@angular/core';
import {CropperSettings} from 'ng2-img-cropper';
import {
  NavController,
  NavParams,
  ViewController,
  LoadingController,
} from 'ionic-angular';

import {AuthProvider} from '../../providers/auth/auth';

@Component({
  selector: 'page-profile-image',
  templateUrl: 'profile-image.html',
})
export class ProfileImagePage implements OnInit {
  @ViewChild('cropper') cropper = undefined;
  title = 'Profile Image';
  buttonText = 'Save and Upload';
  isUploading = false;
  isLoadingImage = true;
  imgData: any;
  cropperSettings: CropperSettings;
  profileImage = '';
  profileImageUrl = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private authProvider: AuthProvider,
    public loadingCtrl: LoadingController,
  ) {
    console.log(this.navParams.data['image'].src);

    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 512;
    this.cropperSettings.height = 512;
    this.cropperSettings.croppedWidth = 256;
    this.cropperSettings.croppedHeight = 256;
    this.cropperSettings.canvasWidth = 512;
    this.cropperSettings.canvasHeight = 512;
    this.cropperSettings.dynamicSizing = true;
    this.cropperSettings.cropperClass = 'img-cropper';
    this.cropperSettings.croppingClass = 'img-cropping';
    this.cropperSettings.minWidth = 256;
    this.cropperSettings.minHeight = 256;
    this.cropperSettings.compressRatio = 0.4;
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.fileType = 'image/jpg';
    this.cropperSettings.touchRadius = 30;

    this.imgData = this.navParams.data['image'];
  }

  ngOnInit() {
    const self = this;
    let loader = self.loadingCtrl.create({
      content: 'Loading image...',
    });
    loader.present();
    setTimeout(() => {
      self.isLoadingImage = false;
      loader.dismiss();
      self.cropper.setImage(self.imgData);
    }, 800);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfileImagePage');
  }

  dismiss() {
    const self = this;
    let data = {
      profileImage: self.profileImage,
      profileImageUrl: self.profileImageUrl,
    };
    self.viewCtrl.dismiss(data);
  }

  processImage() {
    const self = this;
    const croppedImage: Blob = self.authProvider.dataURItoBlob(
      self.imgData.image,
    );
    console.log(croppedImage);

    self.startUploading(croppedImage);
  }

  startUploading(file) {
    const self = this;
    self.isUploading = true;
    self.buttonText = 'Uploading...';
    let progress = 0;

    let loader = self.loadingCtrl.create({
      content: 'Uploading image...',
    });
    loader.present();

    self.authProvider
      .getFbUser()
      .then(user => {
        console.log(user);
        const uid = user.uid;
        const d = new Date();
        const n = d.getTime();
        const filename = 'profile-' + n + '.jpg';

        const metadata = {
          contentType: 'image/jpg',
          name: filename,
          cacheControl: 'max-age=31536000',
        };

        const uploadTask = self.authProvider.storageRef
          .child(`user-profiles/${uid}/${filename}`)
          .put(file, metadata);

        uploadTask.on(
          'state_changed',
          function(snapshot) {
            progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
          },
          function(error) {
            console.log(error.code);
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;

              case 'storage/canceled':
                // User canceled the upload
                break;

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
            }
          },
          function() {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                console.log('File available at', downloadURL);
                self.profileImageUrl = downloadURL;
                self.profileImage = filename;
                self.dismiss();
                loader.dismiss();
              });
          },
        );
      })
      .catch(err => {
        console.log(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile-image/profile-image.ts